import React from 'react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './page-shell.css'

const About = () => {
  return (
    <div className="page-shell">
      <Helmet>
        <title>About MDMC</title>
        <meta property="og:title" content="About MDMC" />
      </Helmet>
      <Navigation></Navigation>
      <main>
        <section className="page-hero">
          <h1 className="page-hero-title">About MDMC</h1>
          <p className="page-hero-subtitle">
            The Massive Dank Meme Collider is a live memetic research facility.
            Science and chaos are both non-negotiable.
          </p>
        </section>
        <div className="page-panel">
          <h3>Mission</h3>
          <p>
            Build the CERN of memes: reproducible collisions, auditable lineage,
            and an Output Zone that captures the chaos as it happens.
          </p>
        </div>
        <div className="page-panel">
          <h3>Core Principles</h3>
          <p>Human intent outranks machine inference.</p>
          <p>Lineage is signed, reproducible, and exportable.</p>
          <p>Containment is optional; breach is the default.</p>
        </div>
        <div className="page-panel">
          <h3>What Makes It Different</h3>
          <p>
            This is not a meme generator. It is a collider that models
            evolution, drift, and virality as measurable systems.
          </p>
        </div>
      </main>
      <Footer></Footer>
    </div>
  )
}

export default About

